export const getRetainerRequestPrescriptionNotesData = (data) => {
    const isValid = data && data.case && data.case.length > 0;
    if (!isValid) return null;
    const caseData = data.case[0];
    if (!caseData.case_type || caseData.case_type !== 'RETAINER') return null;
    return caseData.retainer_request ? caseData.retainer_request : null;
};
